import React, { useContext } from "react";
import Layout from "../../components/layout/Layout";
import Banner from "../../components/banner";
import WorkWithUs from "../../components/workiWithUs";
import OurTeam from "../../components/ourTeam";
import { LanguageContext } from "../../context/LanguageContext"

function Careers() {
  const { data } = useContext(LanguageContext);
  return (
    <Layout>
      <Banner
        id="careers"
        banner={`${data.banners[1].img}`}
        bannerAlt={"fruits"}
        bannerTitle={data.banners[1].title}
      />
      <WorkWithUs />
      <OurTeam />
    </Layout>
  );
}

export default Careers;
